export default class Notification {
  constructor (data) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new Notification(json);
  }
}
